import { Marker, Polyline, Popup, Polygon  } from 'react-leaflet';
import { useRef, useEffect, useState } from 'react';
import React from "react";
import useZoomLevel from '../../Optics/Markers/useZoomLevel'; 
import { CONST_CANTON, CONST_HIGHWAY, FOB, iconWifiAp, iconWifiAPPlanned, iconWifiBSPlanned, iconWifiHotspot, iconWifiStation, iconWifiSTPlanned } from '../../Optics/Constants/ConstantsOptics';
import ShowEditingCoorComponent from '../../Optics/Drawing/ShowEditingCoorComponent';
import { UpdateFobCoordinateConstruction, UpdateWifiCoordinate } from '../WriteData/UpdateWifiCommunications';
import { icon100pab } from '../../AutoTopology/constants/MapConstants';
import { NETSTAT_SWITCH_URL, SERVICE_HOUSE_URL } from '../../Optics/OpticApiConfig';
import L from "leaflet";
import WifiSwitchLines from './WifiSwitchLines';
import WifiUplinkLines from './WifiUplinkLines';
import WifiCoverageSector from './WifiCoverageSector';
import SwitchMarkers from './SwitchMarkers';
//import { UpdateFobCoordinate } from '../UpdateData/UpdateCommunications';

const MarkersTwoIconViewingWifiPoint = ({ data, layersVisibilityCommunications,
   isLineDrawing, flag, openModalWithContent, statusModalTerritory, highwayFlag, cantonFlag, showPonLayer, showKtvLayer, showEtherLayer, isComponentChangeCoor,
   setIsComponentChangeCoor,  user, type, switches, showWifiCoverage, showLinePointToPointWifi, showLineSwToPointWifi, showSwitch, showBaseStation, showStation, showAp, refresh }) => {

  const zoomLevel = useZoomLevel();
  const newCoordinates = useRef({});
  const [dashOffset, setDashOffset] = useState(0);
   // локальное состояние координат
  const [positions, setPositions] = useState({});

  useEffect(() => {
    const interval = setInterval(() => {
      setDashOffset((prev) => (prev + 1) % 20); // смещение пунктира
    }, 50); // скорость анимации
    return () => clearInterval(interval);
  }, []);

 // если пришли новые данные — обновляем позиции, но только если мы не редактируем
  useEffect(() => {
    if (!isComponentChangeCoor) {
      const initialPositions = {};
      data.forEach((item) => {
        initialPositions[item.id] = [item.latitude, item.longitude];
      });
      setPositions(initialPositions);
    }
  }, [data, isComponentChangeCoor]);

  
   const handleMarkerDragEnd = (event, id) => {
    const { lat, lng } = event.target.getLatLng();

    // обновляем позицию маркера локально
    setPositions((prev) => ({
      ...prev,
      [id]: [lat, lng],
    }));

    // сохраняем для последующего сохранения
    newCoordinates.current = { id, lat, lng };
  };


   const handleSave = () => {
    const { id, lat, lng } = newCoordinates.current;
    if (!id) return;
    UpdateWifiCoordinate(id, lat, lng, user, refresh);
    newCoordinates.current = {};
    setIsComponentChangeCoor(false);
  };

  return (
   <>
    {data.map((item, index) => {
      if (zoomLevel <= 13) return null;

      if (
        (item.wifiTypeId === 1 && !showBaseStation) ||
        (item.wifiTypeId === 2 && !showStation) ||
        (item.wifiTypeId === 3 && !showAp)
      ) {
        return null;
      }


      let markerIcon;
      if (item.wifiTypeId === 1) {
        markerIcon = item.planned === 1 ? iconWifiBSPlanned : iconWifiAp;
      } else if (item.wifiTypeId === 2) {
        markerIcon = item.planned === 1 ? iconWifiSTPlanned : iconWifiStation;
      } else if (item.wifiTypeId === 3) {
        markerIcon = item.planned === 1 ? iconWifiAPPlanned : iconWifiHotspot;
      } else {
        markerIcon = iconWifiAPPlanned;
      }

      const eventHandlers = {};
        if (!isLineDrawing) {
          eventHandlers.click = () => openModalWithContent(item, cantonFlag);
        }

       const position = positions[item.id] || [item.latitude, item.longitude];


      return (
        <>
          {/* 🔹 WiFi маркер */}
          <Marker
            key={item.id ?? index}
            position={position}
            icon={markerIcon}
            draggable={isComponentChangeCoor}
            eventHandlers={{
              click: eventHandlers.click,
              dragend: (event) => handleMarkerDragEnd(event, item.id),
            }}
          />

          {/* 🔹 Пунктирные линии uplink */}
          {showLinePointToPointWifi && (
            <WifiUplinkLines
              key={`uplink-${item.id ?? index}`}
              item={item}
              data={data}
              dashOffset={dashOffset}
            />
          )}

          {/* 🔹 Линии Wi-Fi ↔ Switch */}
          {showLineSwToPointWifi  && zoomLevel >= 18 && (
            <WifiSwitchLines
              key={`swline-${item.id ?? index}`}
              item={item}
              switches={switches}
            />
          )}

          {/* 🔹 Сектора покрытия Wi-Fi */}
          {showWifiCoverage && zoomLevel >= 16 && (
            <WifiCoverageSector
              key={`sector-${item.id ?? index}`}
              item={item}
              index={index}
            />
          )}
        </>
      );
    })}

    {/* 🔹 Switch-маркеры */}
    {showSwitch && zoomLevel >= 18 &&
      <SwitchMarkers 
        switches={switches} 
      />}
 







        {/* Компонент для сохранения или отмены изменений */}
        <ShowEditingCoorComponent
          isComponentChangeCoor={isComponentChangeCoor}
          setIsComponentChangeCoor={setIsComponentChangeCoor}
          handleSave={handleSave} 
        />
    </>
  );
}

export default MarkersTwoIconViewingWifiPoint;


